import React from 'react';

const TemplateCopy = (props: any) => {
  const { fill } = props;
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.5 15.025H3.975V15.5C3.975 16.1697 4.24103 16.8119 4.71456 17.2854C5.18809 17.759 5.83033 18.025 6.5 18.025H15.5C16.1697 18.025 16.8119 17.759 17.2854 17.2854C17.759 16.8119 18.025 16.1697 18.025 15.5V6.5C18.025 5.83033 17.759 5.18809 17.2854 4.71456C16.8119 4.24103 16.1697 3.975 15.5 3.975H15.025V3.5C15.025 2.83033 14.759 2.18808 14.2854 1.71456C13.8119 1.24103 13.1697 0.975 12.5 0.975H3.5C2.83033 0.975 2.18808 1.24103 1.71456 1.71456C1.24103 2.18808 0.975 2.83033 0.975 3.5V12.5C0.975 13.1697 1.24103 13.8119 1.71456 14.2854C2.18808 14.759 2.83033 15.025 3.5 15.025ZM15.5 5.025C15.8912 5.025 16.2664 5.1804 16.543 5.45702C16.8196 5.73363 16.975 6.10881 16.975 6.5V15.5C16.975 15.8912 16.8196 16.2664 16.543 16.543C16.2664 16.8196 15.8912 16.975 15.5 16.975H6.5C6.10881 16.975 5.73363 16.8196 5.45702 16.543C5.1804 16.2664 5.025 15.8912 5.025 15.5V15.025H12.5C13.1697 15.025 13.8119 14.759 14.2854 14.2854C14.759 13.8119 15.025 13.1697 15.025 12.5V5.025H15.5ZM2.025 3.5C2.025 3.10881 2.1804 2.73363 2.45702 2.45702C2.73363 2.1804 3.10881 2.025 3.5 2.025H12.5C12.8912 2.025 13.2664 2.1804 13.543 2.45702C13.8196 2.73363 13.975 3.10881 13.975 3.5V12.5C13.975 12.8912 13.8196 13.2664 13.543 13.543C13.2664 13.8196 12.8912 13.975 12.5 13.975H3.5C3.10881 13.975 2.73363 13.8196 2.45702 13.543C2.1804 13.2664 2.025 12.8912 2.025 12.5V3.5Z"
          fill={fill}
          stroke="#545454"
          strokeWidth="0.05"
        />
      </svg>
    </>
  );
};

export default TemplateCopy;
